import {DesignScreen} from '../../../stores/DesignScreen';
import {SubscreenCollection} from './SubscreenCollection';
import {override} from 'mobx';

export class SplittedDesignSubscreen extends DesignScreen {
    parentScreen;

    constructor(screen, name, parent) {
        super(screen, name);
        this.parentScreen = parent;
        this.collection = new SubscreenCollection(null);
    }

    get isSplitted() {
        return true;
    }

    setCollection(fields) {
        this.collection.insertFields(this, fields);
    }

    getPackageId(exec) {
        return this.parentScreen.getPackageId(exec);
    }

    @override
    setActive(field) {
        super.setActive(field);
        this.parentScreen.setActive(field);
    }
}
